// /waitlist: signed in, not approved yet. The end of the road until the
// operator approves. Approval is noticed when the person comes back to the
// tab (the approval mail brings them back); the page does not poll.
import { useQuery } from "@tanstack/react-query";
import { useRouter } from "@tanstack/react-router";
import { m } from "@trameria/cloud-i18n";
import { Button, useApi } from "@trameria/ui-core";
import { useEffect, useState } from "react";
import { HOME } from "../auth/next";
import { useCloud } from "../context";
import { desktopFrame } from "../desktop-frame";
import { accountQuery } from "../queries";
import { SignedOutPage } from "./signed-out-page";

export function WaitlistPage() {
  const api = useApi();
  const router = useRouter();
  const { session } = useCloud();
  const account = useQuery(accountQuery(api));
  const [busy, setBusy] = useState(false);
  const approved = account.data?.approved ?? false;
  // frontend-development: not a fetch; leaves the page once approval is seen.
  useEffect(() => {
    if (!approved) return;
    void session.start().then(() => router.history.push(HOME));
  }, [approved, router, session]);
  return (
    <SignedOutPage title={m.web_waitlist_title()}>
      <p className="text-[13px] leading-[1.7]">
        {m.web_waitlist_body({ email: account.data?.email ?? "" })}
      </p>
      {/* Inside the desktop app the account is the app's (its settings, Cloud). */}
      {!desktopFrame && (
        <Button
          className="mt-5"
          disabled={busy}
          onClick={() => {
            setBusy(true);
            void session.signOut().finally(() => setBusy(false));
          }}
        >
          {m.web_waitlist_switch()}
        </Button>
      )}
    </SignedOutPage>
  );
}
